export default "__VITE_ASSET__D9tT8Ppv__"